<template>
    <div>
        <div class="Download">
            <ul>
                <li v-for="file in files">
                    <img :src="file.icon_path">
                    <span class="Download__title" >{{ file.title_or_basename }}</span>
                    <a @click.prevent="deleteFilePrompt(file)"><i class="fa fa-trash ml-4"></i></a>
                </li>
            </ul>
        </div>

        <div class="row mr-0 mb-2"
            v-for="(item, i) in state" :key="i"
        >
            <input
                class="col"
                type="file"
                :name="`attachment[${i}][file]`"
            />
            <input
                class="col"
                type="text"
                :name="`attachment[${i}][title]`"
            />
        </div>
        <button class="btn btn-outline-primary" @click.prevent="addAttachment()">Přidat</button>
    </div>
</template>

<script>
    export default {
        props: [
            'saved',
        ],

        data: () => ({
            files: [],
            state: []
        }),

        methods: {
            addAttachment() {
                this.state.push({});
            },

            deleteFilePrompt(file) {
                swal({
                    title: 'Opravdu smzat?',
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Zrušit'
                }).then(result => {
                    if (result.dismiss) {
                        return false;
                    }
                    this.deleteFile(file);
                });
            },

            deleteFile(file) {
                axios.delete(file.delete_link)
                    .then(response => {
                        this.files = this.files.filter(item => item.id !== file.id);
                    });
            }
        },

        mounted() {

            this.files = this.saved;

            if (! this.saved.length) {
                this.addAttachment();
                return;
            }
        }
    }
</script>

<style lang="scss">
</style>
